const styles = (theme) => ({
  supportUsContainer: {
    maxWidth: '1170px',
    marginTop: '30px',
    '& h1': {
      fontFamily: 'Open Sans, sans-serif !important',
      fontSize: 35,
      fontWeight: '300',
      marginBottom: '30px',
      color: theme.palette.common.darkBlue,
    },
  },
  supportUsBackBtn: {
    color: theme.palette.common.darkBlue,
    cursor: 'pointer',
    fontWeight: 'bold',
    marginBottom: '30px',
    '& i': {
      display: 'inline-block',
      marginRight: '2px',
    },
  },
  supportUsContentContainer: {
    '& p': {
      color: theme.palette.common.black,
    },
    '& .support-image-section': {
      [theme.breakpoints.down('sm')]: {
        marginLeft: '0px !important',
        width: '100% !important',
      },
    },
  },
  donateImage: {
    width: '300px',
    marginTop: '20px',
  },
});

export default styles;
